// extracted by mini-css-extract-plugin
var _1 = "EmbedContent-module__animateUploadProgressBarWidth--hLbII";
var _2 = "EmbedContent-module__animatedBackground--I214e";
var _3 = "EmbedContent-module__container--FAckX";
var _4 = "EmbedContent-module__content--mLCkb";
var _5 = "EmbedContent-module__disableContentSelection--WaKbd";
var _6 = "EmbedContent-module__editable--yVRGj";
var _7 = "EmbedContent-module__footer--gno9Y";
var _8 = "EmbedContent-module__hasNativeFooter--KX2RC";
var _9 = "EmbedContent-module__type-google-doc--oZcdW";
var _a = "EmbedContent-module__type-microsoft-office--qSWOb";
var _b = "EmbedContent-module__type-twitter--q_Dgx";
var _c = "EmbedContent-module__wrapper--xA51v";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "disableContentSelection", _6 as "editable", _7 as "footer", _8 as "hasNativeFooter", _9 as "type-google-doc", _a as "type-microsoft-office", _b as "type-twitter", _c as "wrapper" }
